// extracted by mini-css-extract-plugin
export default {"page":"An-z","landingBackground":"Bn-z","nonLandingBackground":"Cn-z"};